import { Feedback } from '@chegg-wt/core-wa/types'
import { SentenceOffset } from '@chegg-wt/core-wa/state/types'
import type { Step } from '@tiptap/pm/transform'
import { Dispatch } from 'redux'
import { AppState } from '@chegg-wt/core/state'

export enum HistoryDeltaAction {
  APPLY = 'APPLY',
  DISCARD = 'DISCARD',
}
export enum HistoryChangeType {
  GRAMMAR = 'grammar',
  PARAPHRASE = 'paraphrase',
  SYNONYM = 'synonym',
  CLARITY = 'clarity',
  EXPAND = 'expand',
  SHORTEN = 'shorten',
}

export enum HistoryInteractionType {
  SUGGESTION_ACCEPTED = 'suggestion accepted',
  SUGGESTION_REJECTED = 'suggestion rejected',
  MANUAL_EDIT = 'manual edit',
  FLAG_SUGGESTION = 'flag suggestion',
}

export interface HistoryChangeDetails {
  type: HistoryChangeType
  action?: HistoryInteractionType
  id?: string // uuid of card - only for suggestions
}

export interface FeedbackDelta {
  feedback: Feedback
  action: HistoryDeltaAction
}

export enum HistorySentenceChange {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
}

export interface SentencesDelta {
  removedSentences: Omit<SentenceOffset, 'originalText' | 'lastUpdated'>[]
  addedSentences: Omit<SentenceOffset, 'originalText' | 'lastUpdated'>[]
}

export interface HistoryCurrentVersion {
  removedGrammarFeedbacks: Set<String>
  removedParaphraseFeedbacks: Set<String>
  addedGrammarFeedbacks: Set<String>
  addedParaphraseFeedbacks: Set<String>
  steps: Step[]
  feedbackDelta: FeedbackDelta[]
  sentencesDelta: SentencesDelta
  sentencesRemovedOnManualChange: SentencesDelta['removedSentences']
  changeDetails?: HistoryChangeDetails // Required only for rio logging
  enableReviewButton?: boolean
}

export interface HistoryVersion extends Omit<HistoryCurrentVersion, 'steps'> {
  stepsJson: JSON[]
}

export type HistoryRemoveGrammarCards = Map<string, Set<string>>
export type HistoryRemoveParaphraseCards = Map<string, boolean> // Making it record instead of set to keep similarity between grammar and paraphrase

export interface RedoFeedbackDeltaParams {
  feedbackDelta: FeedbackDelta[]
  dispatch: Dispatch
  state: AppState
  removedGrammarCards: HistoryRemoveGrammarCards
  removedParaphraseCards: HistoryRemoveParaphraseCards
}

export interface UndoFeedbackDeltaParams {
  feedbackDelta: FeedbackDelta[]
  dispatch: Dispatch
  state: AppState
  removedGrammarCards: HistoryRemoveGrammarCards
  removedParaphraseCards: HistoryRemoveParaphraseCards
}
